import gql from 'graphql-tag'

// eslint-disable-next-line import/prefer-default-export
export const queryByOwnerEmail = gql`
  query QueryByOwnerEmail($after: String, $first: Int) {
    queryByOwnerEmail(after: $after, first: $first) {
      items {
        id
        addedBy
        company
        email
        industry
        firstName
        lastName
        leadId
        leadTitle
        maneuver
        status
        maverickActivated
        name
        sendDates
        isHot
        phoneNumber
        dateAdded
        rank
        missionName
        leadUpdateDate
      }
      nextToken
    }
  }
`

export const getLeadsByIds = gql`
  query GetLeadsByIds($ids: [Int]) {
    getLeadsByIds(ids: $ids) {
      id
      addedBy
      company
      email
      industry
      firstName
      lastName
      leadId
      leadTitle
      maneuver
      status
      maverickActivated
      name
      sendDates
      isHot
      phoneNumber
      rank
    }
  }
`
